<div class="modal-header">
    <h4 class="modal-title">Obtener Resultado Votación</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">

        <div id="stepperForm" class="bs-stepper col-md-12">
            <div class="bs-stepper-header">
                <div class="step" data-target="#test-l-1">
                    <button class="step-trigger">
                        <span class="bs-stepper-circle">1</span>
                        <span class="bs-stepper-label">Datos de la Votación</span>
                    </button>
                </div>
                <div class="line"></div>
                <div class="step" data-target="#test-l-2">
                    <button class="step-trigger">
                        <span class="bs-stepper-circle">2</span>
                        <span class="bs-stepper-label">Resultados</span>
                    </button>
                </div>
            </div>
            <div class="bs-stepper-content">
                <form [formGroup]="form" (ngSubmit)="descifrar()" novalidate>
                    <div id="test-l-1" class="content col-md-12">
                        <div class="card-body table-responsive table-hover p-0 fix-margin-bottom20"
                            style="height: auto; max-height: 600px;">
                            <table class="table table-bordered table-head-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" width="20%">Campo</th>
                                        <th scope="col" width="80%">Contenido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Titulo</td>
                                        <td>{{form.controls.tituloVotacion.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de Inicio</td>
                                        <td>{{form.controls.fechaInicio.value | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de Término</td>
                                        <td>{{form.controls.fechaFin.value | date: 'dd/MM/yyyy HH:mm:ss'}}
                                    </tr>
                                    <tr>
                                        <td>Votos Recibidos</td>
                                        <td>{{form.controls.votosRecibidos.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Votantes</td>
                                        <td>{{form.controls.hashVotantes.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Boleta</td>
                                        <td>{{form.controls.hashBoleta.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Votación</td>
                                        <td>{{form.controls.hashVotacion.value}}</td>
                                    </tr>
                                    <tr>
                                        <td>Hash de Votos</td>
                                        <td>{{form.controls.hashVotos.value}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-12 text-center">
                            <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                                <i class="fa fa-times-circle"></i>
                                Cerrar
                            </button>
                            <button type="button" class="btn btn-info btn-fidelis col-md-4" (click)="next()">
                                <i class="fa fa-arrow-circle-right"></i>
                                Siguiente
                            </button>
                        </div>
                    </div>
                    <div id="test-l-2" class="content col-md-12">
                        <div class="card-body table-responsive table-hover p-0"
                            style="height: auto; max-height: 600px; padding-bottom: 10px !important;"
                            *ngFor="let item of listaPreguntas">
                            <table class="table table-bordered table-head-fixed">
                                <thead>
                                    <tr>
                                        <th scope="col" colspan="3">{{item.pregunta}}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col" width="25%">Opción</th>
                                        <th scope="col" width="50%">Codificación</th>
                                        <th scope="col" width="25%">Resultado</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let opcion of item.listaOpciones">
                                        <td class="capitalize">{{opcion.opcion}}</td>
                                        <td>{{opcion.codificacion}}</td>
                                        <td>{{opcion.resultado}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="capitalize"><strong>Total</strong></td>
                                        <td></td>
                                        <td></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                        <div class="form-group col-md-12" *ngIf="mostrarDescifrar">
                            <label for="llavePrivada">Llave Privada</label>
                            <textarea rows="5" class="form-control" id="llavePrivada" formControlName="llavePrivada"
                                [ngClass]="{ 'is-invalid': submitted && form.controls.llavePrivada.errors }">
                            </textarea>
                            <div *ngIf="submitted && form.controls.llavePrivada.errors" class="invalid-feedback">
                                <div *ngIf="form.controls.llavePrivada.errors.required">Campo requerido</div>
                            </div>
                        </div>
                        <div class="col-md-12 text-center">
                            <button type="button" class="btn btn-info btn-fidelis col-md-4" (click)="previous()">
                                <i class="fa fa-arrow-circle-left"></i>
                                Atrás
                            </button>
                            <button type="submit" class="btn btn-success btn-fidelis col-md-4" *ngIf="mostrarDescifrar">
                                <i class="fa fa-certificate"></i>
                                Descifrar
                            </button>
                            <button type="button" class="btn btn-success btn-fidelis col-md-4" (click)="publicar()"
                                *ngIf="mostrarPublicar">
                                <i class="fa fa-check-circle"></i>
                                Publicar
                            </button>
                            <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="close()"
                                *ngIf="!mostrarDescifrar && !mostrarPublicar">
                                <i class="fa fa-times-circle"></i>
                                Cerrar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>